export default {
    init() {
        const $internalMenu = $('.block-internal-menu');

        if ($internalMenu && $internalMenu.length) {
            $('a', $internalMenu).on('click', function() {
                const $this = $(this);
                const target = $this.attr('href');
                const $targetEl = $(target);

                $('a', $internalMenu).removeClass('active');
                $this.addClass('active');

                // Scroll to the targeted section
                if ($targetEl.length) {
                  const $headerEl = $('header');
                  const headerHeight = $headerEl.height();
                  const menuHeight = $internalMenu.height();
                  const targetOffsetTop = $targetEl.offset().top;
                  const scrollTop = targetOffsetTop - headerHeight - menuHeight;
                  $('html, body').animate({
                    scrollTop,
                  }, 500);
                }

            });

            const setInternalMenuPosition = () => {
                if ($('body > header').css('position') == 'sticky') {
                    $internalMenu.css('top', $('header nav.navbar').outerHeight() + 'px');
                }
                else {
                    $internalMenu.css('top', '-1px');
                }
            }

            setInternalMenuPosition();
            $(window).on('resize', () => {setInternalMenuPosition();});
        }
    },

    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      },
}



// WEBPACK FOOTER //
// ./scripts/routes/blocks/internalMenu.js